export const UPSELL_OFFERS = {
  combo: {
    offerId: "combo",
    priceId: "price_1SsNutLgMJN3Ejvz1dKq4rOr",
    productId: "prod_Tq42qDoaHW0QWF",
  },
  hair: {
    offerId: "hair",
    priceId: "price_1SsNw6LgMJN3Ejvzk1REJRxv",
    productId: "prod_Tq44PWpRs0xHQh",
  },
  outfits: {
    offerId: "outfits",
    priceId: "price_1SsNwsLgMJN3Ejvz5S5BGndQ",
    productId: "prod_Tq45pWjEY1zKuP",
  },
};


